/* eslint-disable react/jsx-pascal-case */
import React from "react";
// import { useSelector, useDispatch } from "react-redux";
import Popper from "@mui/material/Popper";
// web.cjs is required for IE11 support
import { useSpring, animated } from "react-spring";
import { makeStyles } from "@material-ui/core/styles";
// import { API_BASE, Palette } from "../AppConfig";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import PropTypes from "prop-types";
import {
    Box,
    Checkbox,
    Paper,
    IconButton,
    Tooltip,
    Switch,
    TableContainer,
    TableHead,
    TableCell,
    TableBody,
    Table,
    TableRow,
    TableSortLabel,
    Toolbar,
    Typography,
    FormControlLabel,
    Button,
    TextField,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
// import { visuallyHidden } from "@material-ui/core/utils/";
import { alpha } from "@material-ui/core/styles";
import { Add, Edit } from "@material-ui/icons";
import { API_BASE } from "../AppConfig";
import { fetchTimeout } from "../components/Common";
import { Autocomplete } from "@mui/material";
// import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    container: {
        // height: "90%",
        // maxHeight: "800px",
    },
    row: {
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        padding: "2px 0px 2px 24px",
        // color: theme?.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
    },
    categoryHeadingCell: {
        textAlign: "center",
        // backgroundColor: Palette.FieldersOrange + " !important",
        padding: "2px !important",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        borderLeft: "1px solid white !important",
        borderRight: "1px solid white !important",
        position: "sticky",
        top: "0px !important",
    },
    categoryHeadingCellBlank: {
        textAlign: "center",
        backgroundColor: "#ffffff !important",
        padding: "2px !important",
        position: "sticky",
        top: "0px !important",
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        // fontWeight: theme?.brand?.FIELDERS ? "inherit" : "600",
        // fontFamily: theme?.typography?.fontFamilySecondary,
        backgroundColor: "#a8a8a8",
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },
    headingCellSubtype: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        // fontWeight: theme?.brand?.FIELDERS ? "inherit" : "600",
        // fontFamily: theme?.typography?.fontFamilySecondary,
        backgroundColor: "#878787",
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },

    headingRow: {
        // backgroundColor: Palette.FieldersBlue,
    },
    skylightheadingCell: {
        background: "#5ebba7",
    },
    editor: {
        border: "1px solid grey",
        width: "40px",
    },
    noHover: {
        "&:hover": {
            backgroundColor: "transparent !important",
        },
    },
}));

const createData = (file, displayName, notes, conditions, stamped) => {
    return {
        file,
        displayName,
        notes,
        conditions,
        stamped,
    };
};

const Fade = React.forwardRef(function Fade(props, ref) {
    const { in: open, children, onEnter, onExited, ...other } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited();
            }
        },
    });

    return (
        <animated.div ref={ref} style={style} {...other}>
            {children}
        </animated.div>
    );
});

Fade.propTypes = {
    children: PropTypes.element,
    in: PropTypes.bool,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
};

export default function ManageDrawings(props) {
    const classes = useStyles();
    //   const dispatch = useDispatch();
    // Drawings, saveDrawings, close, material list
    const { value, saveValue, onClose, materials } = props;

    const [open, setOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("file");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [updateRow, setUpdateRow] = React.useState("");
    const [updatedState, setUpdatedState] = React.useState(value);
    const [value_, setValue] = React.useState("");
    const [value2, setValue2] = React.useState("");
    const [keyCondition, setKeyCondition] = React.useState("");
    const [valueCondition, setvalueCondition] = React.useState("");
    const [conditionOpen, setConditionOpen] = React.useState(false);

    const handleConditionOpen = () => {
        setConditionOpen(true);
    };

    const handleConditionClose = () => {
        setConditionOpen(false);
    };

    let index = selectedRow?.split("|")[0];
    let key = selectedRow?.split("|")[1];
    let textLabel;

    if (textLabel === undefined) {
        if (key !== (null || undefined) && index !== (null || undefined)) {
            textLabel = updatedState[index][key];
        } else {
            textLabel = "";
        }
    }

    const handleFileClick = (event, updatedState) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(updatedState);
        setSelected([]);
        setUpdateRow(""); // Restart selected row
        setOpen((previousOpen) => !previousOpen);
    };

    const canBeOpen = open && Boolean(selectedRow);
    const id = canBeOpen ? "spring-popper" : undefined;

    let rows = updatedState.map((rows) => {
        return createData(rows?.File, rows?.Name, rows?.Notes, rows?.Conditions, !rows?.NoStamp);
    });

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    // This method is created for cross-browser compatibility, if you don't
    // need to support IE11, you can use Array.prototype.sort() directly
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    const headCells = [
        {
            id: "file",
            numeric: false,
            disablePadding: true,
            label: "File Name ",
        },
        {
            id: "displayName",
            numeric: true,
            disablePadding: false,
            label: "Display Name ",
        },
        {
            id: "notes",
            numeric: true,
            disablePadding: false,
            label: "Internal Notes ",
        },
        {
            id: "Conditions",
            numeric: true,
            disablePadding: false,
            label: "Conditions ",
        },
        {
            id: "stamped",
            numeric: true,
            disablePadding: false,
            label: "Stamped ",
        },
    ];

    function EnhancedTableHead(props) {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                "aria-label": "select all desserts",
                            }}
                        />
                    </TableCell>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" style={{ padding: "0px 5px" }}>
                                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    const handleDeleteSelected = () => {
        let newState = updatedState;
        newState = newState.filter((rows) => {
            if (selected.indexOf(rows.File) > -1) {
                return false;
            }
            return true;
        });
        setSelected([]);
        setUpdatedState(newState);
        saveValue("MASTER", "drawings", newState);
    };

    EnhancedTableHead.propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(["asc", "desc"]).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    function EnhancedTableToolbar(props) {
        const { numSelected } = props;

        return (
            <Toolbar
                sx={{
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    ...(numSelected > 0 && {
                        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                    }),
                }}
            >
                {numSelected > 0 ? (
                    <Typography sx={{ flex: "1 1 100%" }} color="inherit" variant="subtitle1" component="div">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography sx={{ flex: "1 1 100%" }} variant="h6" id="tableTitle" component="div">
                        Drawings
                    </Typography>
                )}

                {numSelected > 0 && (
                    <Tooltip title="Delete">
                        <IconButton onClick={handleDeleteSelected}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </Toolbar>
        );
    }

    EnhancedTableToolbar.propTypes = {
        numSelected: PropTypes.number.isRequired,
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.file);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        setSelected(newSelected);
    };

    const uploadFile = (e) => {
        if (e?.target?.files) handleFiles(e.target.files[0]);
    };

    const uploadMultiFile = (e) => {
        for (var i = 0; i < e.target.files.length; i++) {
            handleFiles(e.target.files[i]);
        }
    };

    const handleFiles = (files) => {
        // if (files.length === 0) return;
        let file = files;
        if (file.name.toLowerCase().endsWith(".pdf")) {
            if (file.size > 2097152) {
                alert("File is too big! Less than 2MB please");
                return;
            }

            var reader = new FileReader();
            reader.onload = function (e) {
                // Check if state has file / if not add file else ignore.
                let found = false;
                if (updatedState?.some && updatedState.some((e) => e.File === file.name)) {
                    /* contains the element we're looking for */
                    found = true;
                }
                if (!found) {
                    let newState = updatedState;

                    newState.push({ File: file.name, Notes: "new line" });

                    setUpdatedState(newState);
                    saveValue("MASTER", "drawings", newState);
                }
                save(e.target.result, file.name);
            };
            reader.readAsDataURL(file);
        }
    };

    const save = (value, name) => {
        let help_base_url = API_BASE() + "document/Drawings";
        fetchTimeout(help_base_url, {
            method: "PUT",
            body: JSON.stringify({
                document_type: "drawing",
                document_name: name,
                document_data: value,
            }),
        })
            // .then(res => (res.ok ? res : Promise.reject(res)))
            .then(async (res) => {
                if (!res.ok) Promise.reject(res);
                else {
                    let text = await res.text();

                    let newState = updatedState;
                    if (newState.at(-1).File === "") {
                        newState.at(-1).File = name;
                        setUpdatedState(newState);
                        handleFileClick(anchorEl, selectedRow);

                        saveValue("MASTER", "drawings", newState);
                    }

                    if (open) setOpen(false);
                }
            });
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    let newState;
    const addCondition = () => {
        newState = updatedState;
        newState[index].Conditions = {
            ...newState[index].Conditions,
            key: "condition",
        };
        // setAnchorEl(anchorEl);
        // setSelectedRow(updatedState);
        // setUpdateRow(""); // Restart selected row
        // setOpen((previousOpen) => !previousOpen);

        // newState = newState.filter((rows) => {
        //   if (selected.indexOf(rows.File) > -1) {
        //     return false;
        //   }
        //   return true;
        // });
        setUpdatedState(newState);
        // handleConditionOpen();
        // saveValue("MASTER", "drawings", newState);
    };

    const getRecommendKeys = () => {
        let keysList = new Set(); // Use Set to avoid duplicate keys

        updatedState.forEach((element) => {
            if (element["Conditions"] && typeof element["Conditions"] === "object") {
                Object.keys(element["Conditions"]).forEach((index) => {
                    keysList.add(index);
                });
            }
        });

        // Convert the Set to an array, sort it alphabetically, and return
        return Array.from(keysList).sort();
    };

    const getRecommendedValues = () => {
        let valuesList = new Set(); // Use Set to avoid duplicate keys

        updatedState.forEach((element) => {
            if (element["Conditions"] && typeof element["Conditions"] === "object") {
                Object.keys(element["Conditions"]).forEach((index) => {
                    const value = element["Conditions"][index];
                    if (value !== null && value !== undefined) {
                        valuesList.add(value);
                    }
                });
            }
        });

        // Convert the Set to an array, sort it alphabetically, and return
        const valuesArray = Array.from(valuesList).sort();
        return valuesArray;
    };

    const handleChangeDense = (event) => {
        setDense(event.target.checked);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    return (
        <>
            <Box
                sx={{ width: "100%" }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <Paper sx={{ width: "100%", mb: 2 }}>
                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer>
                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={dense ? "small" : "medium"}>
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            />
                            <TableBody>
                                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.sort(getComparator(order, orderBy)).slice() */}
                                {stableSort(rows, getComparator(order, orderBy))
                                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        const isItemSelected = isSelected(row.file);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                //
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.file}
                                                selected={isItemSelected}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        onClick={(event) => handleClick(event, row.file)}
                                                        color="primary"
                                                        checked={isItemSelected}
                                                        inputProps={{
                                                            "aria-labelledby": labelId,
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    role="button"
                                                    className={classes.rowCell}
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                    onClick={(event) =>
                                                        handleFileClick(
                                                            event,
                                                            updatedState.findIndex((p) => p.File == row.file) + "|File"
                                                        )
                                                    }
                                                >
                                                    {row.file}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.rowCell}
                                                    align="right"
                                                    onClick={(event) =>
                                                        handleFileClick(
                                                            event,
                                                            updatedState.findIndex((p) => p.File == row.file) + "|Name"
                                                        )
                                                    }
                                                >
                                                    {row.displayName}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.rowCell}
                                                    align="right"
                                                    onClick={(event) =>
                                                        handleFileClick(
                                                            event,
                                                            updatedState.findIndex((p) => p.File == row.file) + "|Notes"
                                                        )
                                                    }
                                                >
                                                    {row.notes}
                                                </TableCell>
                                                <TableCell
                                                    style={{ display: "flex" }}
                                                    className={classes.rowCell}
                                                    align="right"
                                                    onClick={(event) => {
                                                        handleFileClick(
                                                            event,
                                                            updatedState.findIndex((p) => p.File == row.file) +
                                                                "|Condition"
                                                        );
                                                        setOpen(false);
                                                        handleConditionOpen();
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            margin: "auto 5px",
                                                            display: "flex",
                                                            alignItems: "end",
                                                        }}
                                                    >
                                                        {row.conditions?.toString() ? (
                                                            <>
                                                                Edit <Edit />
                                                            </>
                                                        ) : (
                                                            <>
                                                                Add <Add />
                                                            </>
                                                        )}
                                                    </p>
                                                </TableCell>
                                                <TableCell
                                                    className={classes.rowCell}
                                                    align="right"
                                                    onClick={(event) => event.stopPropagation()}
                                                >
                                                    <Tooltip title={row.stamped ? "Engineer stamp will be applied" : "Engineer stamp will NOT be applied"}>
                                                        <Switch
                                                            checked={row.stamped}
                                                            onChange={(event) => {
                                                                let newState = updatedState;
                                                                const rowIndex = newState.findIndex((p) => p.File == row.file);
                                                                newState[rowIndex].NoStamp = !event.target.checked;
                                                                setUpdatedState(newState);
                                                                saveValue("MASTER", "drawings", newState);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}

                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{
                                            height: (dense ? 33 : 53) * emptyRows,
                                        }}
                                    >
                                        <TableCell colSpan={7} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <TableRow style={{ display: "flex" }}>
                            <TableCell />
                            {/* <TableCell>
                                <Button
                                    onClick={(event) => {
                                        let newState = updatedState;
                                        newState = [...newState, { File: "", Name: "", Notes: "new line" }];
                                        setUpdatedState(newState);
                                        handleFileClick(event, "");
                                        setOpen(false);
                                    }}
                                >
                                    Add Drawing
                                </Button>
                            </TableCell> */}
                            <FormControlLabel
                                control={<Switch checked={dense} onChange={handleChangeDense} />}
                                label="Dense padding"
                            />
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <p style={{ color: "#8bd2a8" }}>Bulk Upload or Replace Files</p>
                                <input multiple id="raised-button-file" type="file" onChange={uploadMultiFile} />
                            </div>
                        </TableRow>
                    </TableContainer>
                    {/* <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
                </Paper>

                <Popper
                    onClick={(e) => e.stopPropagation()}
                    id={id}
                    open={open}
                    // selectedRow={anchorEl}
                    anchorEl={anchorEl}
                    transition
                    placement="bottom"
                    disablePortal={false}
                >
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps}>
                            <Paper
                                style={{
                                    padding: "0px 5px 5px 5px",
                                    background: "rgb(255 179 67 / 96%)",
                                    textAlign: "center",
                                    paddingTop: "2px",
                                    minWidth: "50px",
                                    width: `${key === "Condition" || key === "add" ? "600px" : "300px"}`,
                                    height: `${key === "Condition" || key === "add" ? "600px" : "200px"}`,
                                }}
                            >
                                <IconButton
                                    aria-label="delete"
                                    size="small"
                                    onClick={(event) => handleFileClick(event, "")}
                                    style={{ color: "white", position: "absolute", right: "5px" }}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography>{textLabel !== "" && key}</Typography>
                                <Box
                                    style={{
                                        display: "flex",
                                        flexDirection: "Column",
                                        padding: "10px",
                                    }}
                                >
                                    {key === "File" && (
                                        <>
                                            <Button
                                                onClick={() =>
                                                    window.open(
                                                        `${API_BASE() + "document/"}/Drawing/${
                                                            updatedState[index].File.split(".")[0]
                                                        }%7C`,
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                View Current File
                                            </Button>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <p>Upload New File</p>
                                                <input
                                                    // accept="image/pdf"
                                                    // className={classes.input}
                                                    // style={{ display: "none" }}
                                                    id="raised-button-file"
                                                    type="file"
                                                    onChange={uploadFile}
                                                />

                                                {/* <input type="file" name="images" id="imgid" className="imgcls" onChange={this.handleFile} multiple/> */}

                                                {/* <label htmlFor="raised-button-file">
                                                    <div
                                                        onDragOver={dragOver}
                                                        // onDragEnter={dragEnter}
                                                        onDragLeave={dragLeave}
                                                        onDrop={fileDrop}
                                                        style={{
                                                            background: value2?.background
                                                                ? value2?.background
                                                                : "rgb(134 134 134 / 36%)",
                                                            cursor: "pointer",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <div
                                                            className="checkerBG"
                                                            style={{
                                                                backgroundColor: "white",
                                                                minHeight: "50px",
                                                            }}
                                                        >
                                                            <img
                                                                style={{
                                                                    maxHeight: "50px",
                                                                    maxWidth: "150px",
                                                                    textAlign: "center",
                                                                }}
                                                                src={value}
                                                            />
                                                        </div>

                                                        <div
                                                            style={{
                                                                textAlign: "center",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                height: "50px",
                                                            }}
                                                        >
                                                            {"Click or Drag & Drop image file to upload"}
                                                        </div>
                                                    </div>
                                                </label> */}
                                            </div>
                                        </>
                                    )}
                                    {(key === "Name" || key === "Notes") && (
                                        <>
                                            <TextField
                                                style={{ margin: "20px 0px" }}
                                                label={textLabel}
                                                value={updateRow === "" ? textLabel : updateRow}
                                                onChange={(event) => setUpdateRow(event.target.value)}
                                            />
                                            <Button
                                                onClick={(e) => {
                                                    let newState = updatedState;
                                                    newState[index][key] = updateRow;
                                                    setUpdatedState(newState);
                                                    saveValue("MASTER", "drawings", newState);
                                                    handleFileClick(e, "");
                                                }}
                                                style={{ backgroundColor: "lightblue" }}
                                            >
                                                UPDATE
                                            </Button>
                                        </>
                                    )}
                                </Box>

                                {/* <BSL_Button
                                    onClick={() => {
                                        
                                        // setSelectedRow(updateRow);
                                        // setUpdateRow("");
                                        // 
                                    }}
                                >
                                    UPDATE
                                </BSL_Button> */}
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </Box>
            <Dialog
                maxWidth="lg"
                onClick={(e) => {
                    e.stopPropagation();
                }}
                open={conditionOpen}
                onClose={handleConditionClose}
            >
                <DialogTitle>Conditions for {updatedState[index]?.File}</DialogTitle>
                <DialogContent>
                    <>
                        {updatedState[index]?.Conditions &&
                            Object.keys(updatedState[index]?.Conditions)?.map((ind) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                flex: 1,
                                                // justifyContent: "space-between",
                                            }}
                                        >
                                            <Autocomplete
                                                freeSolo
                                                value={ind}
                                                sx={{
                                                    minWidth: 220,
                                                }}
                                                PopperComponent={({ style, ...props }) => (
                                                    <Popper
                                                        {...props}
                                                        style={{ ...style, zIndex: 999999 }} // width is passed in 'style' prop
                                                    />
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        style={{ minWidth: 220 }}
                                                        {...params}
                                                        label={ind}
                                                        onChange={(e) => {
                                                            let inde = index + "|" + ind;
                                                            setKeyCondition({
                                                                ...keyCondition,
                                                                [inde]: [e.target.value],
                                                            });
                                                        }}
                                                    />
                                                )}
                                                onChange={(e, v) => {
                                                    let inde = index + "|" + ind;
                                                    setKeyCondition({
                                                        ...keyCondition,
                                                        [inde]: [v],
                                                    });
                                                }}
                                                options={getRecommendKeys()}
                                            />
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Autocomplete
                                                    value={updatedState[index].Conditions[ind]}
                                                    freeSolo
                                                    PopperComponent={({ style, ...props }) => (
                                                        <Popper
                                                            {...props}
                                                            style={{ ...style, zIndex: 999999 }} // width is passed in 'style' prop
                                                        />
                                                    )}
                                                    onChange={(e, v) => {
                                                        let inde = index + "|" + ind;
                                                        setvalueCondition({
                                                            ...valueCondition,
                                                            [inde]: [v],
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            onChange={(e) => {
                                                                let inde = index + "|" + ind;
                                                                setvalueCondition({
                                                                    ...valueCondition,
                                                                    [inde]: [e.target.value],
                                                                });
                                                            }}
                                                            style={{
                                                                width:
                                                                    Math.min(
                                                                        Math.max(
                                                                            updatedState[index].Conditions[ind]?.length,
                                                                            2
                                                                        ),
                                                                        50
                                                                    ) +
                                                                    25 +
                                                                    "ch",
                                                            }}
                                                            {...params}
                                                            label={updatedState[index].Conditions[ind]}
                                                        />
                                                    )}
                                                    options={getRecommendedValues()}
                                                />{" "}
                                                <Button
                                                    onClick={(e) => {
                                                        let newState = updatedState;

                                                        newState = newState.map((values) => {
                                                            let newVals = values;
                                                            if (values.File === updatedState[index].File) {
                                                                delete newVals.Conditions[ind];
                                                            }
                                                            return newVals;
                                                        });
                                                        setUpdatedState(newState);
                                                        // handleFileClick(anchorEl, selectedRow);
                                                        // setOpen(true);
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </Button>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        <Button
                            onClick={(e) => {
                                // handleFileClick(anchorEl, selectedRow);

                                addCondition();
                                let newState = updatedState;
                                let already = false;
                                if (
                                    valueCondition !== (null || undefined || "") &&
                                    keyCondition === (null || undefined || "")
                                ) {
                                    for (var i = 0; i < Object.keys(valueCondition).length; i++) {
                                        newState[Object.keys(valueCondition)[i].split("|")[0]].Conditions[
                                            Object.keys(valueCondition)[i].split("|")[1]
                                        ] = valueCondition[Object.keys(valueCondition)[i]][0];
                                    }
                                } else if (keyCondition !== (null || undefined || "")) {
                                    for (var i = 0; i < Object.keys(keyCondition).length; i++) {
                                        if (valueCondition !== (null || undefined || "")) {
                                            for (var j = 0; j < Object.keys(valueCondition).length; j++) {
                                                if (
                                                    Object.keys(valueCondition)[j].split("|")[1] ===
                                                    Object.keys(keyCondition)[i].split("|")[1]
                                                ) {
                                                    newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                        keyCondition[Object.keys(keyCondition)[i]]
                                                    ] = valueCondition[Object.keys(valueCondition)[j]][0];

                                                    delete newState[Object.keys(keyCondition)[i].split("|")[0]]
                                                        .Conditions[Object.keys(keyCondition)[i].split("|")[1]];

                                                    already = true;
                                                }
                                            }
                                        }

                                        if (!already) {
                                            newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                keyCondition[Object.keys(keyCondition)[i]]
                                            ] =
                                                newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                    Object.keys(keyCondition)[i].split("|")[1]
                                                ];

                                            delete newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                Object.keys(keyCondition)[i].split("|")[1]
                                            ];
                                        }
                                    }
                                }

                                already = false;
                                setvalueCondition("");
                                setKeyCondition("");
                                setUpdatedState(newState);
                                // handleFileClick(anchorEl, selectedRow);
                                // setOpen(true);
                                saveValue("MASTER", "drawings", newState);
                                // setOpen(true);
                            }}
                        >
                            Add new condition
                        </Button>
                        <Button
                            onClick={(e) => {
                                let newState = updatedState;
                                let already = false;
                                if (
                                    valueCondition !== (null || undefined || "") &&
                                    keyCondition === (null || undefined || "")
                                ) {
                                    for (var i = 0; i < Object.keys(valueCondition).length; i++) {
                                        newState[Object.keys(valueCondition)[i].split("|")[0]].Conditions[
                                            Object.keys(valueCondition)[i].split("|")[1]
                                        ] = valueCondition[Object.keys(valueCondition)[i]][0];
                                    }
                                } else if (keyCondition !== (null || undefined || "")) {
                                    for (var i = 0; i < Object.keys(keyCondition).length; i++) {
                                        if (valueCondition !== (null || undefined || "")) {
                                            for (var j = 0; j < Object.keys(valueCondition).length; j++) {
                                                if (
                                                    Object.keys(valueCondition)[j].split("|")[1] ===
                                                    Object.keys(keyCondition)[i].split("|")[1]
                                                ) {
                                                    newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                        keyCondition[Object.keys(keyCondition)[i]]
                                                    ] = valueCondition[Object.keys(valueCondition)[j]][0];

                                                    delete newState[Object.keys(keyCondition)[i].split("|")[0]]
                                                        .Conditions[Object.keys(keyCondition)[i].split("|")[1]];

                                                    already = true;
                                                }
                                            }
                                        }

                                        if (!already) {
                                            newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                keyCondition[Object.keys(keyCondition)[i]]
                                            ] =
                                                newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                    Object.keys(keyCondition)[i].split("|")[1]
                                                ];

                                            delete newState[Object.keys(keyCondition)[i].split("|")[0]].Conditions[
                                                Object.keys(keyCondition)[i].split("|")[1]
                                            ];
                                        }
                                    }
                                }

                                already = false;
                                setvalueCondition("");
                                setKeyCondition("");
                                setUpdatedState(newState);
                                // handleFileClick(anchorEl, selectedRow);
                                // setOpen(true);
                                saveValue("MASTER", "drawings", newState);
                            }}
                        >
                            SAVE
                        </Button>
                    </>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConditionClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
